import React, { useState, useEffect, useRef } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from "@mui/material/Button"
import '../css/Face2face.css'
import audio from '../public/Alert.mp3'
import { Typography } from "@mui/material";
import { fetchApi1 } from '../api/fetchapi1'
import { fetchApi } from '../api/fetchapi'


export default function Face2face({ data , data1}) {

    const [eusstg, setEusstg] = useState(localStorage.getItem("eusstg4") || 'skyblue');
    const [weustg, setWeustg] = useState(localStorage.getItem("weustg4") || "skyblue")
    const [ejpprd, setEjpprd] = useState(localStorage.getItem("ejpprd4") || "skyblue")
    const [eusprd, setEusprd] = useState(localStorage.getItem("eusprd4") || "skyblue")
    const [weuprd, setWeuprd] = useState(localStorage.getItem("weuprd4") || "skyblue")
    const [wusprd, setWusprd] = useState(localStorage.getItem("wusprd4") || "skyblue")

    const count = useRef(0);

    const [eusstgCount, setEusstgCount] = useState(0);
    const [weustgCount, setWeustgCount] = useState(0);
    const [eusprdCount, setEusprdCount] = useState(0);
    const [weuprdCount, setWeuprdCount] = useState(0);
    const [ejpprdCount, setEjpprdCount] = useState(0);
    const [wusprdCount, setWusprdCount] = useState(0);

    const d = [
        {
            enviorment: eusstg,
            count: eusstgCount,
            name: 'EUS-stg',
            env: 'staging',
            region: 'eus'
        }, {
            enviorment: weustg,
            count: weustgCount,
            name: 'WEU-stg',
            env: 'staging',
            region: 'weu'
        }, {
            enviorment: wusprd,
            count: wusprdCount,
            name: 'WUS-prd',
            env: 'production',
            region: 'wus'
        }, {
            enviorment: eusprd,
            count: eusprdCount,
            name: 'EUS-prd',
            env: 'production',
            region: 'eus'
        }, {
            enviorment: weuprd,
            count: weuprdCount,
            name: 'weu-prd',
            env: 'production',
            region: 'weu'
        }, {
            enviorment: ejpprd,
            count: ejpprdCount,
            name: 'EJP-prd',
            env: 'production',
            region: 'ejp'
        },
    ]

    const playAudio = () => {
        new Audio(audio).play();
    }

    const fetchFace2face = async () => {
        fetchApi(d, 'face2face', setEusstg, setWeustg, setEjpprd, setEusprd, setWeuprd, setWusprd, setEusstgCount, setWeustgCount, setEusprdCount, setWeuprdCount, setEjpprdCount, setWusprdCount)
    }
    const fetchFace2face1 = async () => {
        fetchApi1('face2face', setEusstg, setWeustg, setEjpprd, setEusprd, setWeuprd, setWusprd, setEusstgCount, setWeustgCount, setEusprdCount, setWeuprdCount, setEjpprdCount, setWusprdCount)
    }
    /* eslint-disable */
    useEffect(() => {
        if (data && count.current === 0) {
            fetchFace2face1()
            count.current = count.current + 1;
        }if (data1 && count.current === 0) {
            fetchFace2face()
            count.current = count.current + 1;
        }
        else if (weuprdCount >= 2) {
            playAudio()
        }
        else if (eusprdCount >= 2) {
            playAudio()
        }
        else if (ejpprdCount >= 2) {
            playAudio()
        }
        else if (weustgCount >= 2) {
            playAudio()
        }
        else if (eusstgCount >= 2) {
            playAudio()
        }
        if (wusprdCount >= 2) {
            playAudio()
        }
    }, [data, data1, eusstgCount, weustgCount, ejpprdCount, eusprdCount, weuprdCount, wusprdCount])

    return (<React.Fragment>
        <Typography sx={{
            marginTop: 5,
            marginLeft: 4,
            fontStyle: 'italic'
        }} align='left' variant='h3'>Face2Face Monitor</Typography>
        <Grid item xs={12} container spacing={1}>
            {d.map((item, index) => {
                return (
                    <Box key={item.name} className='item' sx={{
                        backgroundColor: item.enviorment,
                        borderRadius: '35px',
                        width: '140px'
                    }}><div>{item.count}</div>
                        <Button onClick={fetchFace2face} sx={{
                            p: 3,
                            color: 'black',
                            fontSize: 19,
                            fontWeight: 'bold'
                        }}>{item.name}</Button>
                    </Box>
                )
            })}
        </Grid>
    </React.Fragment>
    )
}